module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pf-29af7118e5407cdb127d237e1323c636.svg";